import {animate, group, query, state, style, transition, trigger} from '@angular/animations';

export const thumbAnimation = trigger('thumbAnimation', [
  state('0', style({ opacity: 0 })),
  state('1', style({ opacity: 1 })),
  transition('0 => 1', animate('300ms ease-in-out'))
]);

export const loaderAnimation = trigger('loaderAnimation', [
  state('0', style({ opacity: 1 })),
  state('1', style({ opacity: 0 })),
  transition('0 => 1', animate('300ms ease-in-out'))
]);

export const loaderHeightAnimation = trigger('loaderHeightAnimation', [
  state('0', style({ height: '220px' })),
  state('1', style({ height: 'auto' })),
  transition('0 => 1', animate('300ms ease-in-out'))
]);




// WEBPACK FOOTER //
// ./src/app/shared/animations/document-thumb.animation.ts